import React, { useState, useEffect } from "react";
import classNames from "classnames";
import { Field } from "formik";
import InputErrorMessage from "../InputErrorMessage/InputErrorMessage";
import PropTypes from "prop-types";
import * as styles from "@app/components/FormikHelper/FormikHelper.module.scss";
import { useLocation } from "react-router-dom";

const FieldHelper = (props) => {
	const { groupError = false, errorCallback = () => {}, instantRequired = false } = props;
	const CurrentField = props.component;
	const [error, setError] = useState({
		hasError: false,
		errorMessage: "",
	});
	const className = classNames({
		"js-error": error.hasError,
		[props.className]: !!props.className,
		[styles.required]: props.required,
	});
	const location = useLocation();
	const { summaryLink } = location.state || {};

	useEffect(() => {
		errorCallback(error);
	}, [error.hasError]);

	return (
		<Field name={props.name}>
			{(formikProps) => {
				useEffect(() => {
					const fieldHasError =
						Boolean(formikProps.meta.touched && formikProps.meta.error) ||
						Boolean(summaryLink && formikProps.meta.error) ||
						Boolean(instantRequired && formikProps.meta.error);

					setError({
						hasError: fieldHasError,
						errorMessage: fieldHasError ? formikProps.meta.error : "",
					});
				}, [formikProps.meta.touched, formikProps.meta.error, summaryLink, instantRequired]);

				return (
					<>
						<CurrentField
							{...props}
							ref={props.extraOpenRef}
							className={className}
							hasError={error.hasError}
							field={formikProps.field}
							form={formikProps.form}
						/>
						{!groupError && <InputErrorMessage show={error.hasError} msg={error.errorMessage} />}
					</>
				);
			}}
		</Field>
	);
};

FieldHelper.propTypes = {
	groupError: PropTypes.bool,
	errorCallback: PropTypes.func,
};

export default FieldHelper;
